import { IconClock } from '../../../../../../../components/icons/IconClock'
import { HorseTrainer } from '../../../../../../../components/rider/HorseTrainer/HorseTrainer'
import { TimeSelector } from '../TimeSelector'

import { generateName } from '../../../../../../../helpers/helpers'
import { cn } from '../../../../../../../lib/utils'

import { IBreakRegistrationByDay } from '../../../../../../../models/events/event.interface'
import { IEventTeamMemberInterface } from '../../../../../../../hooks/useEventRiderTeamMembers'

import { IMAGE_CONSTS } from '../../../../../../../const/image-const'
import {
  HORSE_NAME_DEFAULT,
  IRegistrationByDayInterface,
} from '../../../../../../../models/registrations-by-day/registrationByDay.interface'

export const getClassColumns = ({
  eventTeamMembers,
  eventTeamMembersLoading,
  saveHandlerBreak,
}: {
  eventTeamMembers: IEventTeamMemberInterface
  eventTeamMembersLoading: boolean
  saveHandlerBreak: (h: string, m: string, a: string, id: string) => void
}) => {
  return [
    {
      cell: (info: any) => {
        const row = info.row.original as IBreakRegistrationByDay

        if (row.isBreakDrag) {
          return (
            <div className={'flex items-center gap-4'}>
              <span
                className={
                  'w-[44px] h-[44px] rounded-full flex items-center justify-center bg-[#F6F7FB]'
                }
              >
                <IconClock />
              </span>

              <span className="text-SeabiscuitDark200ThemeColor font-medium text-base flex items-center">
                Break{' '}
                <span className="text-SeabiscuitDark200ThemeColor/80 text-sm mx-1 inline-flex items-center">
                  /
                </span>{' '}
                Drag
              </span>
            </div>
          )
        }
        return (
          <div className="flex items-center gap-4">
            <span className="w-11 h-11 rounded-full block shrink-0 my-2 overflow-hidden">
              <img
                src={row?.riderProfilePicture || IMAGE_CONSTS.PLACEHOLDERS.USER}
                alt="icons"
                className="object-cover w-full h-full rounded-full"
                onError={(e) =>
                  ((e.target as any).src = `https://ui-avatars.com/api/?name=${generateName(
                    row.riderName || ''
                  )}&background=FFFFFF&format=svg&bold=true&color=BCC6D5&rounded=true`)
                }
              />
            </span>
            <div className="flex flex-col">
              <span className="text-SeabiscuitDark200ThemeColor text-base">{row.riderName}</span>
              <span className="text-SeabiscuitDark200ThemeColor/60 text-nr flex items-center">
                {Number(row.backNumber) > 0 ? (
                  <>{row.backNumber}</>
                ) : (
                  <span className=" inline-flex items-center text-SeabiscuitDark200ThemeColor/60 ">
                    No back number
                  </span>
                )}
              </span>
            </div>
          </div>
        )
      },
      id: 'rider',
      header: () => (
        <span className="text-gray-400 font-normal text-[0.875rem] flex items-center">
          <span className="whitespace-nowrap">Rider & Back Number</span>
        </span>
      ),
    },
    {
      cell: (info: any) => {
        const row = info.row.original as IBreakRegistrationByDay

        if (row.isBreakDrag) return <></>

        return (
          <div className="flex items-center gap-4">
            <span className="w-11 h-11 rounded-full block shrink-0 my-2 overflow-hidden">
              <img
                src={row?.horseProfilePicture || IMAGE_CONSTS.PLACEHOLDERS.USER}
                alt="icons"
                className="object-cover w-full h-full rounded-full"
                onError={(e) =>
                  ((e.target as any).src = `https://ui-avatars.com/api/?name=${generateName(
                    row.horseName || ''
                  )}&background=FFFFFF&format=svg&bold=true&color=BCC6D5&rounded=true`)
                }
              />
            </span>
            <div className="flex flex-col">
              <span className="text-SeabiscuitDark200ThemeColor text-base">
                {row.horseName || HORSE_NAME_DEFAULT}
              </span>
              <span className="text-SeabiscuitDark200ThemeColor/60 text-nr flex items-center">
                <HorseTrainer
                  eventTeamMembers={eventTeamMembers}
                  eventTeamMembersLoading={eventTeamMembersLoading}
                  rider={row as IRegistrationByDayInterface}
                />
              </span>
            </div>
          </div>
        )
      },
      id: 'horse',
      header: () => (
        <span className="text-gray-400 font-normal text-[0.875rem] flex items-center">
          <span className="whitespace-nowrap">Horse & Trainer</span>
        </span>
      ),
    },
    {
      id: 'order',
      header: () => (
        <span className="text-gray-400 font-normal text-[0.875rem] flex justify-center items-center ">
          <span className="whitespace-nowrap">Order of Go</span>
        </span>
      ),
      cell: (info: any) => {
        const row = info.row.original as IBreakRegistrationByDay
        const isOutOfTurn = row.isOutOfTurn

        const data = info.table.options.data as IBreakRegistrationByDay[]
        const nonOtItems = data.filter((item) => !item.isOutOfTurn)
        const count = nonOtItems.findIndex((item) => item.id === row.id) + 1

        return (
          <div className="flex justify-center">
            {!row.orderOfGoScratched && (
              // && !row.isScratched
              <span
                className={`rounded-full ${row.isBreakDrag ? 'bg-[#122B460D] text-[#122B46]' : 'bg-SeabiscuitMainThemeColor/5 text-SeabiscuitMainThemeColor'} text-base flex items-center justify-center w-10 h-10`}
              >
                {isOutOfTurn ? 'OT' : count}
              </span>
            )}
          </div>
        )
      },
    },
    {
      header: () => (
        <span className="text-gray-400 font-normal text-[0.875rem] flex items-center justify-center w-full">
          <span className="whitespace-nowrap">Ride Time</span>
        </span>
      ),
      id: 'rideTime',
      cell: (info: any) => {
        const row = info.row.original as IBreakRegistrationByDay

        if (row.isBreakDrag && row.time && row.id) {
          const timeArr = `${row.time}`.split(':')
          const h = timeArr[0]
          const m = timeArr[1]
          const s = timeArr[2]

          return (
            <div className="text-SeabiscuitDark200ThemeColor text-nr justify-center w-full flex">
              <TimeSelector
                h={h}
                m={m}
                s={s}
                saveHandler={(h, m, a) => saveHandlerBreak(h, m, a, row.id)}
              />
            </div>
          )
        }

        return (
          <div className="text-SeabiscuitDark200ThemeColor text-nr justify-center w-full flex">
            {row.orderOfGoScratched ? (
              <span className="text-SeabiscuitDark200ThemeColor/50">Dropped</span>
            ) : (
              <span className={cn(row.isScratched && 'line-through')}>
                {row.rideTimeScheduleByClass}
              </span>
            )}
          </div>
        )
      },
    },
  ]
}
